export var RecordSearchTimeType;
(function (RecordSearchTimeType) {
    RecordSearchTimeType["CREATED_AT"] = "created_at";
    RecordSearchTimeType["SETTLED_AT"] = "settled_at";
    RecordSearchTimeType["GAME_START_AT"] = "game_start_at";
})(RecordSearchTimeType || (RecordSearchTimeType = {}));
//# sourceMappingURL=RecordSearchTimeType.js.map